import { useState } from "react";

export const ChapterReader = ({ chapters }) => {
  const [idx, setIdx] = useState(0);
  const ch = chapters[idx];
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-10">
      <nav className="space-y-1 lg:sticky lg:top-28 self-start" data-testid="chapter-index">
        {chapters.map((c, i) => (
          <button key={c.numeral} data-testid={`chapter-tab-${c.numeral}`} onClick={() => setIdx(i)}
            className={`w-full text-left flex gap-3 px-3 py-2.5 text-sm transition-colors ${i === idx ? "bg-[var(--g-dark,#3B1B48)] text-[#FAF7F2]" : "text-[#1C181D] hover:bg-[var(--g-mist,#EFE6F3)]"}`}>
            <span className="font-display text-[var(--g-accent,#C59B27)] w-8 shrink-0">{c.numeral}.</span><span className="truncate">{c.title}</span>
          </button>
        ))}
      </nav>
      <article key={ch.numeral} className="rise max-w-3xl" data-testid="chapter-content">
        <div className="bg-[var(--g-dark,#3B1B48)] text-[#FAF7F2] px-10 py-12 mb-10">
          <p className="font-display text-5xl text-[var(--g-accent,#C59B27)]">{ch.numeral}</p>
          <h2 className="font-display text-3xl lg:text-4xl mt-3">{ch.title}</h2>
          <p className="font-display italic text-[var(--g-mist,#EFE6F3)] mt-3">{ch.subtitle}</p>
        </div>
        <p className="font-display italic text-xl text-[var(--g-dark2,#4A1E5C)] leading-relaxed mb-10">{ch.intro}</p>
        {ch.sections.map((s, i) => (
          <section key={i} className="mb-10">
            <h3 className="font-display text-2xl text-[var(--g-dark,#3B1B48)] mb-4">{s.heading}</h3>
            <div className="prose-guide" dangerouslySetInnerHTML={{ __html: s.html }} />
            {s.tip && (
              <div className="bg-[var(--g-mist,#EFE6F3)] border-l-4 border-[var(--g-accent,#C59B27)] px-6 py-4 mt-4">
                <p className="eyebrow mb-1">Insider tip</p>
                <p className="font-display italic text-[var(--g-dark,#3B1B48)]">{s.tip}</p>
              </div>
            )}
          </section>
        ))}
        {ch.sources?.length > 0 && (
          <div className="border-t border-[#E2D9CC] pt-4 text-xs text-[#8C827A] break-all space-y-1">
            <p className="eyebrow !text-[#8C827A]">Chapter sources</p>
            {ch.sources.map((u) => <a key={u} href={u} target="_blank" rel="noreferrer" className="block hover:text-[var(--g-dark,#3B1B48)]">{u}</a>)}
          </div>
        )}
      </article>
    </div>
  );
};
